import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { PlusOutlined, SaveOutlined } from '@ant-design/icons';

import { checkModulePermissions } from '../../utils/helper';
import {
	Row,
	Col,
	Button,
	Input,
	Tag,
	theme,
	Space,
	Tooltip,
	notification,
} from 'antd';
import { getConfigurationByIdApi } from '../../actions/getConfigurationByIdAction';
import { getConfigurationsApi } from '../../actions/getConfigurationsAction';
import {
	editConfigurationApi,
	editConfigurationReset,
} from '../../actions/editConfigurationAction';
import { addConfigurationApi } from '../../actions/addConfigurationAction';
import { deleteConfigurationApi } from '../../actions/deleteConfigurationAction';
import {
	getConfigurationOptionsApi,
	getConfigurationOptionsReset,
} from '../../actions/getConfigurationOptionsAction';
import {
	XThemeFilterButton,
	XThemeFilterCards,
	XThemeFilterCircleButton,
	XThemeInputText,
	XThemeTag2,
} from '../../styles/GlobalThemeStyle';
import { XTheme2Button } from '../../styles/GlobalThemeStyleCQ';

const AdminConfigurations = (props) => {
	const {
		getConfigurationsState,
		editConfigurationState,
		getConfigurations,
		editConfiguration,
		editConfigurationReset,
	} = props;
	let modulePermissions = checkModulePermissions('configurations');

	const { token } = theme.useToken();

	const [optionsData, setOptionsData] = useState({});
	const [inputVisible, setInputVisible] = useState('');
	const [inputValue, setInputValue] = useState('');

	const handleClose = (removedTag, tagName, setTagName) => {
		const newOptionsData = optionsData.map((config) => {
			const newOptions = config.options.filter(
				(opt) => opt.value !== removedTag.value,
			);
			return { ...config, options: newOptions };
		});

		setOptionsData(newOptionsData);
	};
	const showInput = (value) => {
		setInputVisible(value);
	};

	const handleInputChange = (e) => {
		setInputValue(e.target.value);
	};

	const handleInputConfirm = (optionsData, setOptionsData, dynamicKey) => {
		if (inputValue && dynamicKey) {
			setOptionsData((prevOptionsData) => {
				const updatedOptionsData = prevOptionsData.map((option) => {
					if (option.key === dynamicKey) {
						return {
							...option,
							options: [
								...option.options,
								{ value: inputValue, label: inputValue },
							],
						};
					}
					return option;
				});
				return updatedOptionsData;
			});
		}

		setInputVisible(false);
		setInputValue('');
	};

	const handleAddConfig = (_id) => {
		const foundConfig = optionsData.find((config) => config.id === _id);
		editConfiguration({ _id: _id, config: foundConfig });
		return foundConfig ? foundConfig.options : [];
	};

	// const tagInputStyle = {
	// 	width: 150,
	// 	height: 22,
	// 	marginInlineEnd: 8,
	// 	verticalAlign: 'top',
	// };
	const tagPlusStyle = {
		height: 22,
		// backgroundColor: token.colorBgContainer,
		backgroundColor: '#169191',
		border: 'none',
		color: theme.colors?.white || '#FFF',
	};

	useEffect(() => {
		checkModulePermissions('configurations').sub_modules.includes(
			'view-configuration-options',
		) && getConfigurations({});
	}, []);

	useEffect(() => {
		if (getConfigurationsState.apiState === 'success') {
			if (getConfigurationsState.data.all_configurations.length > 0) {
				let updatedData = [];
				getConfigurationsState.data.all_configurations.map((option) => {
					updatedData.push({
						name: option.name,
						key: option.key,
						options: option.options,
						id: option._id,
					});
				});

				setOptionsData(updatedData);
			}
		}
	}, [getConfigurationsState]);

	useEffect(() => {
		if (editConfigurationState.apiState === 'success') {
			notification.success({
				message: editConfigurationState.message,
			});
		}
		if (editConfigurationState.apiState === 'error') {
			notification.error({
				message: editConfigurationState.message,
			});
		}
		editConfigurationReset();
	}, [editConfigurationState]);

	return (
		<>
			{getConfigurationsState.apiState === 'success' &&
				optionsData.length > 0 &&
				optionsData.map((option, index) => {
					return (
						<XThemeFilterCards key={index} className="mb-3">
							<Row
								gutter={(15, 15)}
								className="align-items-center"
							>
								<Col xs={24} sm={24} md={20} lg={20}>
									<Row>
										<Col
											xs={6}
											sm={3}
											lg={3}
											xl={2}
											xxl={1}
										>
											<img
												src={`/images/${option.key}.svg`}
												alt=""
											/>
										</Col>
										<Col
											xs={18}
											sm={21}
											lg={21}
											xl={22}
											xxl={21}
										>
											<Row>
												<Col xs={24}>
													<h1 className="cardTitle">
														{option.name}
													</h1>
												</Col>
												<Col xs={24}>
													<Space
														style={{
															flexWrap: 'wrap',
														}}
													>
														{option.options.map(
															(
																tags,
																configIndex,
															) => {
																let tag =
																	tags.label;

																const isLongTag =
																	tag?.length >
																	20;
																const tagElem =
																	(
																		<XThemeTag2
																			key={
																				tag
																			}
																			closable={
																				modulePermissions.sub_modules.includes(
																					'remove-configuration-options',
																				)
																					? true
																					: false
																			}
																			style={{
																				userSelect:
																					'none',
																			}}
																			onClose={() =>
																				handleClose(
																					tags,
																					optionsData,
																					setOptionsData,
																				)
																			}
																		>
																			<span
																				onDoubleClick={(
																					e,
																				) => {
																					e.preventDefault();
																				}}
																			>
																				{isLongTag
																					? `${tag.slice(
																							0,
																							20,
																					  )}...`
																					: tag}
																			</span>
																		</XThemeTag2>
																	);
																return isLongTag ? (
																	<Tooltip
																		title={
																			tag
																		}
																		key={
																			tag
																		}
																	>
																		{
																			tagElem
																		}
																	</Tooltip>
																) : (
																	tagElem
																);
															},
														)}
														{inputVisible ===
														option.name ? (
															<XThemeInputText
																type="text"
																// style={
																// 	tagInputStyle
																// }
																value={
																	inputValue
																}
																onChange={
																	handleInputChange
																}
																onBlur={() =>
																	handleInputConfirm(
																		option.options,
																		setOptionsData,
																		option.key,
																	)
																}
																onPressEnter={() =>
																	handleInputConfirm(
																		option.options,
																		setOptionsData,
																		option.key,
																	)
																}
															/>
														) : (
															<>
																{modulePermissions.sub_modules.includes(
																	'add-configuration-options',
																) ? (
																	<XThemeTag2
																		style={
																			tagPlusStyle
																		}
																		icon={
																			<PlusOutlined />
																		}
																		onClick={() =>
																			showInput(
																				option.name,
																			)
																		}
																	>
																		{`New ${option.name}`}
																	</XThemeTag2>
																) : (
																	false
																)}
															</>
														)}
													</Space>
												</Col>
											</Row>
										</Col>
									</Row>
								</Col>

								<Col
									xs={24}
									sm={24}
									md={4}
									lg={4}
									className="mt-3 mt-md-0 text-end"
								>
									<XTheme2Button
										size="large"
										type="primary"
										// icon={<SaveOutlined />}
										onClick={() => {
											handleAddConfig(option.id);
										}}
									>
										Save
									</XTheme2Button>
								</Col>
							</Row>
						</XThemeFilterCards>
					);
				})}
		</>

		// </XContainer>
		// </>
	);
};

const mapStateToProps = (state) => ({
	getConfigurationByIdState: state.getConfigurationById,
	getConfigurationsState: state.getConfigurations,
	editConfigurationState: state.editConfiguration,
	addConfigurationState: state.addConfiguration,
	deleteConfigurationState: state.deleteConfiguration,
	getConfigurationOptionsState: state.getConfigurationOptions,
});

const mapDispatchToProps = (dispatch) => ({
	getConfigurationById: (params) => dispatch(getConfigurationByIdApi(params)),
	getConfigurations: (params) => dispatch(getConfigurationsApi(params)),
	editConfiguration: (params) => dispatch(editConfigurationApi(params)),
	addConfiguration: (params) => dispatch(addConfigurationApi(params)),
	deleteConfiguration: (params) => dispatch(deleteConfigurationApi(params)),
	getConfigurationOptions: (params) =>
		dispatch(getConfigurationOptionsApi(params)),
	getConfigurationOptionsReset: (params) =>
		dispatch(getConfigurationOptionsReset(params)),
	editConfigurationReset: () => dispatch(editConfigurationReset()),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps,
)(AdminConfigurations);
